'use client';

import { getCookie } from 'cookies-next';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { TOKENS } from 'src/const/auth';

export function AuthRedirect() {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const accessToken = getCookie(TOKENS.accessToken);
    const isMainPage = pathname.split('/').filter(Boolean).length === 1; // Only locale in path

    if (accessToken && isMainPage) {
      router.replace('/dashboard');
    }
  }, [router, pathname]);

  return null;
}
